<div class="wrapper">
    <div>
        <app-ocean-service-banner></app-ocean-service-banner>
    </div>

    <div>
        <app-ocean-service-content></app-ocean-service-content>
    </div>
</div>